const DATA = {
  name: `Hey, I'm Ashwin`,
  subtext: `Architect, Entrepreneur`,
  jobStatus: `Software Development Engineer II @ Capillary`,
  twitterURL: `https://twitter.com/ashwinkumar`,
  instaURL: `https://www.instagram.com/ashwinnaidu/`,
  githubURL: `https://github.com/ashwinnaidu`,
  linkedinURL: `https://www.linkedin.com/in/ashwinnaidu`,
  resumeURL: `https://ashwinkumar.co/resume2017.pdf`,
};

export default DATA;



// WEBPACK FOOTER //
// ./src/app/app.data.js